const getCurrentLocation = () => window.location

export default getCurrentLocation
